<template>
  <div class="result">
    <TodayResult />
    <HistoryResults :length="30" />
  </div>
</template>
<script>
import TodayResult from './components/TodayResult'
import HistoryResults from './components/HistoryResults'

export default {
  components: {
    TodayResult,
    HistoryResults
  }
}
</script>
<style lang="scss">
.result {

}
</style>
